export const KEY_TO_ABBREVIATION_MAPPER = {
  Dinner: 'D',
  Lunch: 'L',
  Breakfast: 'BKFST',
  Brunch: 'BR',
  'Hors d\'Oeuvres': 'HD',
  'Interactive Experience': 'IE'
};
